import React , {useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './Css/index.css';
import './Css/Responsive.css'
import Aos from "aos";
import 'aos/dist/aos.css'
import Base from './components/layout/Base';
import Home from './components/element/Home';

function App() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // Animation duration in milliseconds
    });
  } , []);


  return (
    <>
     <Base>
        <Home/>
     </Base>
    </>
  );
}

export default App;
